import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-main',
		path: ['/admin'],
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_main" */ './index'), {
			exportName: 'AdminMain',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
